package com.gsb.vyapar.bhagya.util

class Stack<T> {
    private val list = LinkedList<T>()

    fun push(item: T) {
        list.addLast(item)
    }

    fun pop(): T? {
        if (list.isEmpty()) {
            return null
        }
        return list.removeLast()
    }

    fun peek(): T? {
        if (list.isEmpty()) {
            return null
        }
        return list.getLast()
    }

    fun isEmpty(): Boolean {
        return list.isEmpty()
    }

    fun size(): Int {
        return list.size()
    }
}
